// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3M3LG","requiredAsterisk":"Info_requiredAsterisk__2xoHA"};